import React, { FC, ReactNode } from 'react';
import { Icon, Typography } from '@npm-registry/eapteka-ui';
import { IconNameMedium } from '@npm-registry/eapteka-ui/lib/components/Icon/icons';
import styles from './Informer.scss';

interface InformerProps {
  iconName?: IconNameMedium;
  iconColor?: string;
  children: ReactNode;
}

export const Informer: FC<InformerProps> = ({
  iconName = 'infoRound',
  iconColor = '#9199a3',
  children
}) => {
  return (
    <div className={styles.root}>
      {iconName && (
        <div
          className={styles.icon}
          style={{ color: iconColor }}
        >
          <Icon name={iconName} />
        </div>
      )}
      <div className={styles.text}>
        <Typography>{children}</Typography>
      </div>
    </div>
  );
};
